<template>
    <div>
        <main>
            <router-view />
        </main>
    </div>
</template>

<script lang="ts" setup>

</script>

<style>
@import "https://d3kx8o9mol3zjn.cloudfront.net/admin/css/common.css";
@import "https://d3kx8o9mol3zjn.cloudfront.net/admin/css/style.css";
</style>